import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { NotificationGroupMemberEntity } from './notification-group-member.entity';
import { NotificationEntity } from './notification.entity';

@Index('_fk__notification__id', ['fkNotificationId'], {})
@Index(
	'_fk__notification_group_member__id',
	['fkNotificationGroupMemberId'],
	{},
)
@Entity('_notification__notification_group__state')
export class NotificationNotificationGroupStateEntity extends BaseEntity {
	@Column('int', { name: '_fk__notification_group_member__id', unsigned: true })
	public fkNotificationGroupMemberId!: number;

	@Column('int', { name: '_fk__notification__id', unsigned: true })
	public fkNotificationId!: number;

	@Column('tinyint', { name: '_read', width: 1, default: () => "'0'" })
	public read!: boolean;

	@Column('varchar', { name: '_metadata', nullable: true, length: 100 })
	public metadata!: string | null;

	@Column('text', { name: '_error', nullable: true })
	public error!: string | null;

	@Column('varchar', { name: '_errorCode', nullable: true, length: 20 })
	public errorCode!: string | null;

	@Column('tinyint', { name: '_isMentioned', width: 1, default: () => "'0'" })
	public isMentioned!: boolean;

	@ManyToOne(
		() => NotificationGroupMemberEntity,
		(notificationGroupMember) =>
			notificationGroupMember.notificationNotificationGroupStates,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__notification_group_member__id', referencedColumnName: 'id' },
	])
	public fkNotificationGroupMember!: NotificationGroupMemberEntity;

	@ManyToOne(
		() => NotificationEntity,
		(notification) => notification.notificationNotificationGroupStates,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__notification__id', referencedColumnName: 'id' }])
	public fkNotification!: NotificationEntity;
}
